import { IRoom } from './index'

export default function(api: GlobalFetch) {
  return async function(roomId: IRoom[keyof Pick<IRoom, 'id'>]) {
    const response = await api.fetch(`/api/v2/room/index/id_room/${roomId}`, {
      method: 'DELETE',
    })

    return await response.json()
  }
}
